import { render, staticRenderFns } from "./dataoverview.vue?vue&type=template&id=af6b0c5c&scoped=true"
import script from "./dataoverview.vue?vue&type=script&lang=js"
export * from "./dataoverview.vue?vue&type=script&lang=js"
import style0 from "./dataoverview.vue?vue&type=style&index=0&id=af6b0c5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6b0c5c",
  null
  
)

export default component.exports